import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <ul>
                        <li>© <script>document.write(new Date().getFullYear())</script> Mortgage Support</li>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Terms</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    );
};

export default Footer;